const HANDBALL_STATISTIC_PLAYER_FIELDS = [
  {
    id: 'gamesCount',
    title: 'Сыграно игр'
  },
  {
    id: 'wonGamesCount',
    title: 'Победы'
  },
  {
    title: 'Очки',
    data: [
      {
        id: 'totalGoals',
        title: 'Голы'
      },
      {
        id: 'assists',
        title: 'Передачи'
      },
      {
        id: 'goalsPercent',
        title: '% реализации',
        percent: true
      },
      {
        id: 'points',
        title: 'Всего'
      }
    ]
  },
  {
    title: 'Удары',
    data: [
      {
        id: 'shots',
        title: 'Всего'
      },
      {
        id: 'shotsOnGoal',
        title: 'В створ'
      },
      {
        id: 'shotsBlocked',
        title: 'Заблок.'
      },
      {
        id: 'shotsOnGoalPercent',
        title: 'Меткость',
        percent: true
      }
    ]
  },
  {
    title: '7М',
    data: [
      {
        id: 'penaltyGoals',
        title: 'Забитые'
      },
      {
        id: 'penaltyAttempts',
        title: 'Исполненные'
      },
      {
        id: 'penaltyGoalsPercent',
        title: '%',
        percent: true
      }
    ]
  },
  {
    id: 'turnovers',
    title: 'Потери'
  },
  {
    title: 'Защита',
    data: [
      {
        id: 'steals',
        title: 'Перехваты'
      },
      {
        id: 'blockShots',
        title: 'Блоки'
      },
    ]
  },
  {
    title: 'Наказания',
    data: [
      {
        id: '2’',
        title: 'Желтые карточки'
      },
      {
        id: 'yellowCards',
        title: 'Желтые карточки'
      },
      {
        id: 'redCards',
        title: 'Красные карточки'
      }
    ]
  }
];

const HANDBALL_GOALKEEPER_STATISTIC_FIELDS = [
  {
    id: 'gamesCount',
    title: 'Сыграно игр'
  },
  {
    id: 'wonGamesCount',
    title: 'Победы'
  },
  {
    id: 'totalGoalsAgainst',
    title: 'Голы пропущено'
  },
  {
    title: 'С игры',
    data: [
      {
        id: 'saves',
        title: 'Сейвы'
      },
      {
        id: 'shotsAgainst',
        title: 'Удары в створ'
      },
      {
        id: 'savesPercent',
        title: '% сейвов',
        percent: true
      }
    ]
  },
  {
    title: 'Пенальти',
    data: [
      {
        id: 'penaltySaves',
        title: 'Сейвы'
      },
      {
        id: 'penaltyShotsAgainst',
        title: 'Удары с пенальти'
      },
      {
        id: 'penaltySavesPercent',
        title: '% сейвов',
        percent: true
      }
    ]
  },
  {
    title: '10-метровые',
    data: [
      {
        id: 'smallPenaltySaves',
        title: 'Сейвы'
      },
      {
        id: 'smallPenaltyShotsAgainst',
        title: 'Удары с 10-метровых'
      },
      {
        id: 'smallPenaltySavesPercent',
        title: '% сейвов',
        percent: true
      }
    ]
  },
  {
    title: 'Доп. статистика',
    data: [
      {
        id: 'userMinutes',
        title: 'Мин.'
      },
      {
        id: 'plusMinus',
        title: '+/-'
      }
    ]
  }
];

export function getHandballStatisticHeader(goalie: boolean, forTeam?: boolean) {
  const stat = [...(goalie ? HANDBALL_GOALKEEPER_STATISTIC_FIELDS : HANDBALL_STATISTIC_PLAYER_FIELDS)];
  if (forTeam) {
    stat.splice(3, 3);
    stat.splice(1, 1, {id: 'tournamentPoints', title: 'Набранные очки'});
    stat[2] = {...stat[2]};
    stat[2].data = [...stat[2].data];
    stat[2].data.splice(0, 1);
    stat[2].data.unshift(
      {
        id: 'teamPlusMinus',
        title: 'Разница голов'
      }, {
        id: 'teamScoreSum',
        title: 'Забито'
      }, {
        id: 'teamMissedSum',
        title: 'Пропущено'
      },
    );
    stat.splice(3, 0, {
      title: 'Результаты', data: [
        {id: 'wonGamesCount', title: 'Победы'},
        {id: 'drawGamesCount', title: 'Ничьи'},
        {id: 'loseGamesCount', title: 'Поражения'},
      ]
    });
  }
  return stat;
}
